import clearIsDirty from '../../actions/clearIsDirty';
import getOwaUserConfigurationOperation from 'owa-service/lib/operation/getOwaUserConfigurationOperation';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import initializeDateTime from 'owa-shared-bootstrap/lib/initializeDateTime';
import OwaUserConfiguration from 'owa-service/lib/contract/OwaUserConfiguration';
import saveTimeZoneOption from '../../actions/timeZone/saveTimeZoneOption';
import setMailboxRegionalConfiguration from '../../services/setMailboxRegionalConfiguration';
import TimeZoneViewState from '../../store/schema/TimeZoneViewState';
import updateUserOptions from '../../utils/updateUserOptions';
import { getOptionsStore } from '../../store/Store';
import { hideFullScreenSpinner, showFullScreenSpinner } from 'mini-full-screen-spinner';
import { orchestrator } from 'satcheljs';
import { returnTopExecutingActionDatapoint } from 'owa-analytics';
import { updateServiceConfig } from 'owa-service/lib/config';
import { timeZoneChanged } from '../../actions/timeZone/timeZoneChanged';

const saveTimeZoneOptionOptionOrchestrator = orchestrator(
    saveTimeZoneOption,
    async (actionMessage: {}) => {
        const optionsStore = getOptionsStore();
        if (optionsStore && optionsStore.activeViewState) {
            // start the spinner
            showFullScreenSpinner();

            // make the changes remotely
            const viewState = optionsStore.activeViewState as TimeZoneViewState;
            const { selectedTimeZone } = viewState;
            const userOptions = getUserConfiguration().UserOptions;

            if (selectedTimeZone !== userOptions.TimeZone) {
                updateServiceConfig({ timezone: selectedTimeZone });
                const datapoint = returnTopExecutingActionDatapoint();
                datapoint && datapoint.addCustomProperty('tz', selectedTimeZone);

                const mailboxConfigResponse = await setMailboxRegionalConfiguration(
                    selectedTimeZone
                );

                if (mailboxConfigResponse.WasSuccessful) {
                    // When time zone changes there are several properties under
                    // user configuration that change as well: time zone, working hours,
                    // time zone offsets, preferred time zones to display and maybe others.
                    // Hence reloading the entire config and re-initializing the affected stores.
                    const userConfiguration: OwaUserConfiguration = await getOwaUserConfigurationOperation();
                    updateUserOptions(userConfiguration);
                    initializeDateTime(false /* shouldInitializeTimeZoneAnonymously */);
                    clearIsDirty(); // save was successful hence disable the save button
                }
                timeZoneChanged();
            } else {
                clearIsDirty(); // nothing to save
            }

            // remove the spinner
            hideFullScreenSpinner();
        }
    }
);

export default saveTimeZoneOptionOptionOrchestrator;
